import { createFileRoute } from '@tanstack/react-router';
import { BrevoPage } from '@/components/admin/brevo/BrevoPage.tsx';

export const Route = createFileRoute('/_app/admin/brevo')({
  staticData: { orgScope: 'none' },
  component: BrevoPage,
});
